import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeads, fetchRemoveLead } from "../../../../redux/slices/leads";
import SideBar from "../../SideBar";
import Alert from "../components/Alert";
import Empty from "../components/Empty";
import Notification from "../components/Notification";
import Title from "../components/Title";

export default function Leads() {
  const dispatch = useDispatch();
  const { leads } = useSelector((state) => state.leads);

  const [open, setOpen] = useState(false);
  const [target, setTarget] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    dispatch(fetchLeads());
  }, [dispatch]);

  const askDelete = (id) => {
    setTarget(id);
    setOpen(true);
  };

  const confirmDelete = () => {
    dispatch(fetchRemoveLead(target));
    setShow(true);
    setTimeout(() => setShow(false), 3500);
  };

  return (
    <SideBar>
      <Alert
        open={open}
        setOpen={setOpen}
        text={"Удалить заявку?"}
        subText={"Вы уверены? Действие нельзя будет отменить."}
        btnText={"Удалить"}
        deleteClicked={confirmDelete}
      />
      <Notification
        show={show}
        setShow={setShow}
        text={"Заявка удалена!"}
        state={"success"}
      />
      <Title text={"Заявки"} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-6">
        {leads.items && leads.items.length > 0 ? (
          <>
            <div className="text-lg font-medium mb-4">
              {`Всего заявок: ${leads.items.length}`}
            </div>
            <div className="overflow-x-auto rounded-xl border border-neutral-200 shadow">
              <table className="min-w-full divide-y divide-neutral-200">
                <thead className="bg-neutral-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-500">
                      Дата
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-500">
                      Имя
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-500">
                      Телефон
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-500">
                      Email
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-500">
                      Тур / услуга
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-500">
                      Человек
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-500">
                      Переводчик
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-500">
                      Комментарий
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-500">
                      Язык
                    </th>
                    <th className="px-4 py-3" />
                  </tr>
                </thead>
                <tbody className="divide-y divide-neutral-200 bg-white">
                  {leads.items.map((lead) => (
                    <tr key={lead._id} className="hover:bg-neutral-50">
                      <td className="px-4 py-3 text-sm text-neutral-500 whitespace-nowrap">
                        {lead.date}
                      </td>
                      <td className="px-4 py-3 text-sm font-medium text-neutral-900 whitespace-nowrap">
                        {`${lead.firstName} ${lead.lastName}`}
                      </td>
                      <td className="px-4 py-3 text-sm text-neutral-700 whitespace-nowrap">
                        {lead.phone ? (
                          <a
                            href={`tel:${lead.phone}`}
                            className="text-sky-600 hover:underline"
                          >
                            {lead.phone}
                          </a>
                        ) : (
                          "—"
                        )}
                      </td>
                      <td className="px-4 py-3 text-sm text-neutral-700 whitespace-nowrap">
                        {lead.email ? (
                          <a
                            href={`mailto:${lead.email}`}
                            className="text-sky-600 hover:underline"
                          >
                            {lead.email}
                          </a>
                        ) : (
                          "—"
                        )}
                      </td>
                      <td className="px-4 py-3 text-sm text-neutral-700">
                        {lead.subject || "—"}
                      </td>
                      <td className="px-4 py-3 text-sm text-neutral-700 whitespace-nowrap">
                        {lead.people || "—"}
                      </td>
                      <td className="px-4 py-3 text-sm whitespace-nowrap">
                        {lead.needTranslator ? (
                          <span className="inline-flex items-center rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700">
                            Да
                          </span>
                        ) : (
                          <span className="text-neutral-400">—</span>
                        )}
                      </td>
                      <td className="px-4 py-3 text-sm text-neutral-700 max-w-xs">
                        {lead.comment ? (
                          <span className="whitespace-pre-wrap break-words">
                            {lead.comment}
                          </span>
                        ) : (
                          <span className="text-neutral-400">—</span>
                        )}
                      </td>
                      <td className="px-4 py-3 text-sm text-neutral-500 uppercase">
                        {lead.lang}
                      </td>
                      <td className="px-4 py-3 text-right">
                        <button
                          onClick={() => askDelete(lead._id)}
                          type="button"
                          aria-label="Удалить"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-5 h-5 cursor-pointer text-red-600 hover:text-red-400"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                            />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <Empty
            text={"Заявок пока нет"}
            subText={"Здесь появятся заявки, оставленные через форму на сайте."}
            svg={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="mx-auto h-12 w-12 text-neutral-400"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25z"
                />
              </svg>
            }
          />
        )}
      </div>
    </SideBar>
  );
}
